import { AUTH_TOKEN, SIGNIN, SIGNOUT_SUCCESS, USER_INFO } from "../constant";

const userObj = localStorage.getItem(USER_INFO);
const token = localStorage.getItem(AUTH_TOKEN);
const initialState = {
	token: token,
	user: userObj && { user: JSON.parse(userObj) },
};

const AuthReducer = (state = initialState, action) => {
	switch (action.type) {
		case SIGNIN:
			return {
				...state,
				user: action.payload,
			};
		case SIGNOUT_SUCCESS: {
			return {
				user: null,
			};
		}

		default:
			return state;
	}
};

export default AuthReducer;
